import React, { useCallback, useEffect, useState } from "react";
import { MdKeyboardArrowUp } from "react-icons/md";
import {
  getMaxPageScrollTop,
  resetPageScrollToTop,
  shouldShowPageScrollToTop,
} from "../../../utils/resetPageScrollToTop";
import "./ScrollToTopButton.scss";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    let frame = 0;
    const sync = () => {
      frame = 0;
      setVisible(shouldShowPageScrollToTop(getMaxPageScrollTop()));
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(sync);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    sync();

    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("scroll", onScroll, { capture: true });
    };
  }, []);

  const onClick = useCallback(() => {
    resetPageScrollToTop({ repeat: false, smooth: true });
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="hr-scroll-to-top"
      onClick={onClick}
      aria-label="חזרה לראש העמוד"
      title="חזרה לראש העמוד"
    >
      <MdKeyboardArrowUp className="hr-scroll-to-top__icon" aria-hidden />
    </button>
  );
}
